export const GET_SHIPMENT = 'GET_SHIPMENT';
export const GET_SHIPMENT_SUCCESS = 'GET_SHIPMENT_SUCCESS';
export const GET_SHIPMENT_FAIL = 'GET_SHIPMENT_FAIL';

export const GET_SHIPMENT_UPDATE = 'GET_SHIPMENT_UPDATE';

export const GET_SHIPMENT_ACCEPT = 'GET_SHIPMENT_ACCEPT';
export const GET_SHIPMENT_ACCEPT_SUCCESS = 'GET_SHIPMENT_ACCEPT_SUCCESS';
export const GET_SHIPMENT_ACCEPT_FAIL = 'GET_SHIPMENT_ACCEPT_FAIL';

export const GET_SHIPMENT_REJECT = 'GET_SHIPMENT_REJECT';
export const GET_SHIPMENT_REJECT_SUCCESS = 'GET_SHIPMENT_REJECT_SUCCESS';
export const GET_SHIPMENT_REJECT_FAIL = 'GET_SHIPMENT_REJECT_FAIL';

export const GET_SHIPMENT_CHECK_FIFO = 'GET_SHIPMENT_CHECK_FIFO';
export const GET_SHIPMENT_CHECK_FIFO_SUCCESS = 'GET_SHIPMENT_CHECK_FIFO_SUCCESS';
export const GET_SHIPMENT_CHECK_FIFO_FAIL = 'GET_SHIPMENT_CHECK_FIFO_FAIL';

export const GET_SHIPMENT_CONSIGNMENT_ACCEPT = 'GET_SHIPMENT_CONSIGNMENT_ACCEPT';
export const GET_SHIPMENT_CONSIGNMENT_ACCEPT_SUCCESS = 'GET_SHIPMENT_CONSIGNMENT_ACCEPT_SUCCESS';
export const GET_SHIPMENT_CONSIGNMENT_ACCEPT_FAIL = 'GET_SHIPMENT_CONSIGNMENT_ACCEPT_FAIL';

export const GET_SHIPMENT_ACT_REMOVE_MX3 = 'GET_SHIPMENT_ACT_REMOVE_MX3';
export const GET_SHIPMENT_ACT_REMOVE_MX3_SUCCESS = 'GET_SHIPMENT_ACT_REMOVE_MX3_SUCCESS';
export const GET_SHIPMENT_ACT_REMOVE_MX3_FAIL = 'GET_SHIPMENT_ACT_REMOVE_MX3_FAIL';

export const GET_SHIPMENT_ACT_REMOVE_M15B = 'GET_SHIPMENT_ACT_REMOVE_M15B';
export const GET_SHIPMENT_ACT_REMOVE_M15B_SUCCESS = 'GET_SHIPMENT_ACT_REMOVE_M15B_SUCCESS';
export const GET_SHIPMENT_ACT_REMOVE_M15B_FAIL = 'GET_SHIPMENT_ACT_REMOVE_M15B_FAIL';

export const GET_SHIPMENT_ERROR_CLEAR = 'GET_SHIPMENT_ERROR_CLEAR';
export const GET_SHIPMENT_CLEAR = 'GET_SHIPMENT_CLEAR';

export const GET_SHIPMENT_RETURN_LIST_CAUSE = 'GET_SHIPMENT_RETURN_LIST_CAUSE';
export const GET_SHIPMENT_RETURN_LIST_CAUSE_SUCCESS = 'GET_SHIPMENT_RETURN_LIST_CAUSE_SUCCESS';
export const GET_SHIPMENT_RETURN_LIST_CAUSE_FAIL = 'GET_SHIPMENT_RETURN_LIST_CAUSE_FAIL';

export const GET_SHIPMENT_RETURN = 'GET_SHIPMENT_RETURN';
export const GET_SHIPMENT_RETURN_SUCCESS = 'GET_SHIPMENT_RETURN_SUCCESS';
export const GET_SHIPMENT_RETURN_FAIL = 'GET_SHIPMENT_RETURN_FAIL';

export const GET_SHIPMENT_CONSIGNMENT_CLIENTS_LIST = 'GET_SHIPMENT_CONSIGNMENT_CLIENTS_LIST';
export const GET_SHIPMENT_CONSIGNMENT_CLIENTS_LIST_SUCCESS = 'GET_SHIPMENT_CONSIGNMENT_CLIENTS_LIST_SUCCESS';
export const GET_SHIPMENT_CONSIGNMENT_CLIENTS_LIST_FAIL = 'GET_SHIPMENT_CONSIGNMENT_CLIENTS_LIST_FAIL';

export const GET_SHIPMENT_PLAN_CONTAINER_TYPE = 'GET_SHIPMENT_PLAN_CONTAINER_TYPE';
export const GET_SHIPMENT_PLAN_CONTAINER_TYPE_SUCCESS = 'GET_SHIPMENT_PLAN_CONTAINER_TYPE_SUCCESS';
export const GET_SHIPMENT_PLAN_CONTAINER_TYPE_FAIL = 'GET_SHIPMENT_PLAN_CONTAINER_TYPE_FAIL';

export const GET_SHIPMENT_PLAN = 'GET_SHIPMENT_PLAN';
export const GET_SHIPMENT_PLAN_SUCCESS = 'GET_SHIPMENT_PLAN_SUCCESS';
export const GET_SHIPMENT_PLAN_FAIL = 'GET_SHIPMENT_PLAN_FAIL';

export const GET_SHIPMENT_PLAN_CANCEL = 'GET_SHIPMENT_PLAN_CANCEL';
export const GET_SHIPMENT_PLAN_CANCEL_SUCCESS = 'GET_SHIPMENT_PLAN_CANCEL_SUCCESS';
export const GET_SHIPMENT_PLAN_CANCEL_FAIL = 'GET_SHIPMENT_PLAN_CANCEL_FAIL';

export const GET_NEXT_PLANTS = 'GET_NEXT_PLANTS';
export const GET_NEXT_PLANTS_SUCCESS = 'GET_NEXT_PLANTS_SUCCESS';
export const GET_NEXT_PLANTS_FAIL = 'GET_NEXT_PLANTS_FAIL';

export const GET_NEXT_PLANT = 'GET_NEXT_PLANT';
export const GET_NEXT_PLANT_SUCCESS = 'GET_NEXT_PLANT_SUCCESS';
export const GET_NEXT_PLANT_FAIL = 'GET_NEXT_PLANT_FAIL';

export const GET_SZ_LIST = 'GET_SZ_LIST';
export const GET_SZ_LIST_SUCCESS = 'GET_SZ_LIST_SUCCESS';
export const GET_SZ_LIST_FAIL = 'GET_SZ_LIST_FAIL';
export const GET_SZ_LIST_CLEAR = 'GET_SZ_LIST_CLEAR';

export const ADD_ITEMS_TO_REPORT_OVERDUE = 'ADD_ITEMS_TO_REPORT_OVERDUE';
export const ADD_ITEMS_TO_REPORT_OVERDUE_SUCCESS = 'ADD_ITEMS_TO_REPORT_OVERDUE_SUCCESS';
export const ADD_ITEMS_TO_REPORT_OVERDUE_FAIL = 'ADD_ITEMS_TO_REPORT_OVERDUE_FAIL';

export const UPDATE_SZ = 'UPDATE_SZ';
export const UPDATE_SZ_SUCCESS = 'UPDATE_SZ_SUCCESS';
export const UPDATE_SZ_FAIL = 'UPDATE_SZ_FAIL';

export const UPDATE_SHIPMENT_CHECKED_LIST = 'UPDATE_SHIPMENT_CHECKED_LIST';

export const SET_INITIAL_STATE_SHIPMENT = 'SET_INITIAL_STATE_SHIPMENT';

export const GET_SEPARATIONS_LIST = 'GET_SEPARATIONS_LIST';
export const GET_SEPARATIONS_LIST_SUCCESS = 'GET_SEPARATIONS_LIST_SUCCESS';
export const GET_SEPARATIONS_LIST_FAIL = 'GET_SEPARATIONS_LIST_FAIL';
export const GET_SEPARATIONS_BY_PIECES = 'GET_SEPARATIONS_BY_PIECES';
export const GET_SEPARATIONS_BY_PIECES_SUCCESS = 'GET_SEPARATIONS_BY_PIECES_SUCCESS';
export const GET_SEPARATIONS_BY_PIECES_FAIL = 'GET_SEPARATIONS_BY_PIECES_FAIL';

export const GET_ROLLS_PLACEMENT_TYPES = 'GET_ROLLS_PLACEMENT_TYPES';
export const GET_ROLLS_PLACEMENT_TYPES_SUCCESS = 'GET_ROLLS_PLACEMENT_TYPES_SUCCESS';
export const GET_ROLLS_PLACEMENT_TYPES_FAIL = 'GET_ROLLS_PLACEMENT_TYPES_FAIL';

export const ADD_CLIENT_ARRIVAL_DATE = 'ADD_CLIENT_ARRIVAL_DATE';
export const ADD_CLIENT_ARRIVAL_DATE_SUCCESS = 'ADD_CLIENT_ARRIVAL_DATE_SUCCESS';
export const ADD_CLIENT_ARRIVAL_DATE_FAIL = 'ADD_CLIENT_ARRIVAL_DATE_FAIL';
